class ProductDetailsGrid
{

	constructor(container)
	{
		this.container = container;
		this.pickers = container.querySelectorAll('.pldg__picker-item');
		this.details = container.querySelectorAll('.pldg__details-item');
		this.imageSliders = container.querySelectorAll('.pldg__images-slider');

		this.bindEvents();
	}

	bindEvents()
	{
		this.container.addEventListener('click', (e) => {
			const item = e.target.closest('.pldg__picker-item');
			if (!item) return;

			this.activate(item.dataset.pldgId);
		});

		this.container.addEventListener('focusin', (e) => {
			const item = e.target.closest('.pldg__picker-item');
			if (!item) return;

			this.activate(item.dataset.pldgId);
		});
	}

	activate(id)
	{
		// Update picker state
		this.pickers.forEach(el => {
			el.classList.toggle('pldg__picker-item--active', el.dataset.pldgId === id);
		});

		// Update detail state
		this.details.forEach(el => {
			el.classList.toggle('pldg__details-item--active', el.dataset.pldgId === id);
		});

		// Update image slider state
		this.imageSliders.forEach(el => {
			el.classList.toggle('pldg__images-slider--active', el.dataset.pldgId === id);
		});

		// Fix Swiper scrollbar on change
		requestAnimationFrame(() => {
			const activeSlider = this.container.querySelector(
				'.pldg__images-slider--active'
			);

			if (activeSlider?.swiper)
			{
				activeSlider.swiper.scrollbar?.updateSize();
			}

		});

	}
}


// Init
document.querySelectorAll('.pldg').forEach(el => {
	new ProductDetailsGrid(el);
});